/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetDetailCityResponseDto } from './AssetDetailCityResponseDto';
import {
    AssetDetailCityResponseDtoFromJSON,
    AssetDetailCityResponseDtoFromJSONTyped,
    AssetDetailCityResponseDtoToJSON,
    AssetDetailCityResponseDtoToJSONTyped,
} from './AssetDetailCityResponseDto';

/**
 * 
 * @export
 * @interface AssetDetailSiteResponseDto
 */
export interface AssetDetailSiteResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetDetailSiteResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailSiteResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailSiteResponseDto
     */
    address: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetDetailSiteResponseDto
     */
    latitude: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetDetailSiteResponseDto
     */
    longitude: number | null;
    /**
     * 
     * @type {string}
     * @memberof AssetDetailSiteResponseDto
     */
    postalCode: string | null;
    /**
     * 
     * @type {AssetDetailCityResponseDto}
     * @memberof AssetDetailSiteResponseDto
     */
    city: AssetDetailCityResponseDto | null;
}

/**
 * Check if a given object implements the AssetDetailSiteResponseDto interface.
 */
export function instanceOfAssetDetailSiteResponseDto(value: object): value is AssetDetailSiteResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('postalCode' in value) || value['postalCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    return true;
}

export function AssetDetailSiteResponseDtoFromJSON(json: any): AssetDetailSiteResponseDto {
    return AssetDetailSiteResponseDtoFromJSONTyped(json, false);
}

export function AssetDetailSiteResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetDetailSiteResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'address': json['address'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'postalCode': json['postalCode'],
        'city': AssetDetailCityResponseDtoFromJSON(json['city']),
    };
}

export function AssetDetailSiteResponseDtoToJSON(json: any): AssetDetailSiteResponseDto {
    return AssetDetailSiteResponseDtoToJSONTyped(json, false);
}

export function AssetDetailSiteResponseDtoToJSONTyped(value?: AssetDetailSiteResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'address': value['address'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'postalCode': value['postalCode'],
        'city': AssetDetailCityResponseDtoToJSON(value['city']),
    };
}

